export default {
	id: 'SIMPLE_PREMIUM_FALLBACK_12W_66_65_12W_20_79',
	providers: {
		paltaMap: {
			USD: 'simple_premium_12w_66_65_12w_20_79_usd',
			EUR: 'simple_premium_12w_66_65_12w_20_79_eur',
			GBP: 'simple_premium_12w_66_65_12w_20_79_gbp',
			AUD: 'simple_premium_12w_99_99_12w_31_99_aud',
			CAD: 'simple_premium_12w_89_99_12w_28_79_cad',
			DKK: 'simple_premium_12w_439_12w_135_2_dkk',
			SEK: 'simple_premium_12w_639_12w_199_2_sek',
			NOK: 'simple_premium_12w_669_12w_207_2_nok',
			BRL: 'simple_premium_12w_379_12w_117_59_brl',
			MXN: 'simple_premium_12w_1279_12w_399_2_mxn',
			TRY: 'simple_premium_12w_2900_12w_799_2_try',
			ARS: 'simple_premium_12w_89190_12w_27752_ars',
			COP: 'simple_premium_12w_269990_12w_84392_cop',
			CLP: 'simple_premium_12w_64990_12w_20232_clp',
		},
		primer: 'prd_jH0esNZgQ1Rn',
	},
}
